import type { CSSProperties } from 'react'
import { truncateAddress } from '@jagad/utils'

export type AddressDisplayProps = {
    address: string
    numberOfFirstCharacters?: number
    numberOfLastCharacters?: number
    style?: CSSProperties
}

const AddressDisplay = ({
    address,
    numberOfFirstCharacters = 6,
    numberOfLastCharacters = 4,
    style
}: AddressDisplayProps) => {
    const ellipsis = truncateAddress(address, numberOfFirstCharacters, numberOfLastCharacters)

    return (
        <span style={style}>{ellipsis}</span>
    )
}

export default AddressDisplay
